export default __webpack_public_path__ + "static/media/12.f3960562.png";